export const setDocumentTitle = (title) => {
  if (title.length > 0) {
    title += ' | Salestrigger ';
  }
  else {
    title = 'Salestrigger';
  }

  document.title = title;
}